import { Button, Form, Input, InputNumber, Spin } from "antd";
import React, { useEffect } from "react";
import Select from 'react-select';
import TextArea from "antd/es/input/TextArea";
import { useBooking } from "../../context/BookingContext";
import { useNavigate } from "react-router-dom";
import { usePlayrooms } from "../../context/PlayroomsContext";

export default function ReservationForm() {
  const { bookingState, updateBooking } = useBooking();
  const { choosenPlayroom } = usePlayrooms();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    if (bookingState.packageId === "") {
      navigate("/");
    }
  }, [bookingState.packageId, navigate]);

  const paymentOptions = [
    {
      value: "INVOICE_PAYMENT",
      label: <label className="text-lg font-semibold mb-1">Žiralno</label>,
    },
    {
      value: "IN_PERSON",
      label: <label className="text-lg font-semibold mb-1">Gotovina</label>,
    },
  ];

  const foodOptions = [
    {
      value: "Od igraonice",
      label: <label className="text-lg font-semibold mb-1">Hrana od igraonice</label>,
    },
    {
      value: "Donosite svoju",
      label: (
        <label className="text-lg font-semibold mb-1">Donosim hranu</label>
      ),
    },
  ];

  const onFinish = (values) => {
    updateBooking("expectedNumberOfAdults", values.expectedNumberOfAdults);
    updateBooking("expectedNumberOfChildren", values.expectedNumberOfChildren);
    updateBooking("customerEmail", values.customerEmail);
    updateBooking("customerPhoneNumber", values.customerPhoneNumber);
    updateBooking("childName", values.childName);
    updateBooking("note", values.note);
    updateBooking("customerFirstName", values.customerFirstName);
    updateBooking("customerLastName", values.customerLastName);
    updateBooking("paymentMethod", values.paymentMethod.value);
    if (choosenPlayroom.hasFood) {
      updateBooking("food", values.food.value);
    }
    else {
      updateBooking("food", "Donosimo svoju");
    }
    navigate("/reservation-review");
  };

  const isBookingDataComplete = bookingState?.from && bookingState?.to;

  if (!isBookingDataComplete) {
    return (
      <div className="flex items-center justify-center h-screen bg-blue-100">
        <Spin size="large" />
      </div>
    );
  }

  const isContextSet = bookingState?.packageId !== "";

  if (!isContextSet) {
    return <Spin />;
  }

  const getDefaultOption = (options, value) => {
    return options.find(option => option.value === value);
  };

  return (
    <div className="flex flex-col items-center justify-start h-full ">
      <div className="w-full text-center py-10">
        <p className="text-3xl lg:text-6xl font-bold text-footerBlue">
          {choosenPlayroom?.name || "Selected Playroom"}
        </p>
        <label
          className="block text-footerBlue font-semibold text-xl lg:py-4"
          htmlFor="expectedNumberOfAdults"
        >
          Izaberite paket za proslavu rođendana:
        </label>
      </div>

      <div className="w-full px-2 py-2 flex justify-center">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="w-full max-w-[900px]"
        >
          {/* Customer Name (First and Last Name) */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
            <Form.Item
              name="customerFirstName"
              rules={[{ required: true, message: "Ovo polje je obavezno!" }]}
              initialValue={
                bookingState.customerFirstName !== ""
                  ? bookingState.customerFirstName
                  : ""
              }
            >
              <Input
                className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Vaše ime"
              />
            </Form.Item>

            <Form.Item
              name="customerLastName"
              rules={[{ required: true, message: "Ovo polje je obavezno!" }]}
              initialValue={
                bookingState.customerLastName !== ""
                  ? bookingState.customerLastName
                  : ""
              }
            >
              <Input
                className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Vaše prezime"
              />
            </Form.Item>
          </div>

          {/* Child Name and Phone Number */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 py-2">
            <Form.Item
              name="childName"
              rules={[{ required: true, message: "Ovo polje je obavezno!" }]}
              initialValue={bookingState.childName !== "" ? bookingState.childName : ""}
            >
              <Input
                className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Ime slavljenika/ce"
              />
            </Form.Item>

            <Form.Item
              name="customerPhoneNumber"
              rules={[{ required: true, message: "Ovo polje je obavezno!" }]}
              initialValue={
                bookingState.customerPhoneNumber !== ""
                  ? bookingState.customerPhoneNumber
                  : ""
              }
            >
              <Input
                className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Broj telefona"
              />
            </Form.Item>
          </div>

          {/* Customer Email */}
          <Form.Item
            name="customerEmail"
            rules={[
              {
                required: true,
                message: "Ovo polje je obavezno!",
                type: "email",
              },
            ]}
            initialValue={
              bookingState.customerEmail !== "" ? bookingState.customerEmail : ""
            }
          >
            <Input
              className="h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
              placeholder="Email adresa"
            />
          </Form.Item>

          <div className="flex justify-center my-4">
            <div className="h-[100px] w-[1px] bg-gray-300"></div>
          </div>


          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <Form.Item
              name="expectedNumberOfAdults"
              rules={[
                { required: true, message: "Ovo polje je obavezno!" },
                { max: choosenPlayroom?.maxGuestsNumber, message: "Broj je veći od kapaciteta!" }
              ]}
              initialValue={
                bookingState.expectedNumberOfAdults !== null
                  ? bookingState.expectedNumberOfAdults
                  : null
              }
            >
              <Input
                type="number"
                min={0}
                max={choosenPlayroom?.maxGuestsNumber}
                className="w-full h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Očekivani broj odraslih"
              />
            </Form.Item>

            <Form.Item
              name="expectedNumberOfChildren"
              rules={[{ required: true, message: "Ovo polje je obavezno!" }]}
              initialValue={
                bookingState.expectedNumberOfChildren !== null
                  ? bookingState.expectedNumberOfChildren
                  : null
              }
            >
              <Input
                type="number"
                min={0}
                max={choosenPlayroom?.maxNumberOfChildren}
                className="w-full h-12 text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                placeholder="Očekivani broj djece"
              />
            </Form.Item>
          </div>

          {/* Food and Payment Method */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {choosenPlayroom.hasFood && (
              <Form.Item
                name="food"
                rules={[{ required: choosenPlayroom.hasFood, message: "Ovo polje je obavezno!" }]}
                initialValue={getDefaultOption(foodOptions, bookingState.food)}
              >
                <Select
                  classNamePrefix="react-select"
                  className="w-full h-12 text-lg font-semibold mb-1 text-left"
                  options={foodOptions}
                  defaultValue={getDefaultOption(foodOptions, bookingState.food)} // Set default value
                  placeholder="Ko obezbjeđuje hranu?"
                  isSearchable={false}
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      backgroundColor: "#DCE2EA",
                      borderRadius: "13px",
                      fontSize: "18px",
                      height: "50px",
                      border: state.isFocused ? "2px solid #1890ff" : "none",
                      boxShadow: state.isFocused
                        ? "0 0 0 1px rgba(24, 144, 255, 0.2)"
                        : "none",
                      "&:hover": {
                        border: "1px solid #1890ff",
                      },
                    }),
                    menu: (provided) => ({
                      ...provided,
                      backgroundColor: "#DCE2EA",
                    }),
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      color: "#1890ff",
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      color: "#5B728D",
                      fontSize: "18px",
                      fontWeight: "600",
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: "#4a5568",
                      fontWeight: "600",
                    }),
                  }}
                  onChange={(value) => form.setFieldsValue({ food: value })}
                />
              </Form.Item>
            )}
            <Form.Item
              name="paymentMethod"
              rules={[{ required: true, message: "Ovo polje je obavezno!" }]}
              initialValue={getDefaultOption(paymentOptions, bookingState.paymentMethod)}
            >
              <Select
                classNamePrefix="react-select"
                className="w-full h-12 text-lg font-semibold mb-1 text-left"
                options={paymentOptions}
                defaultValue={getDefaultOption(paymentOptions, bookingState.paymentMethod)} // Set default value
                placeholder="Način uplate avansa"
                isSearchable={false}
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    backgroundColor: "#DCE2EA",
                    borderRadius: "13px",
                    fontSize: "18px",
                    height: "50px",
                    border: state.isFocused ? "2px solid #1890ff" : "none",
                    boxShadow: state.isFocused
                      ? "0 0 0 2px rgba(24, 144, 255, 0.2)"
                      : "none",
                    "&:hover": {
                      border: "1px solid #1890ff",
                    },
                  }),
                  menu: (provided) => ({
                    ...provided,
                    backgroundColor: "#DCE2EA",
                  }),
                  dropdownIndicator: (provided) => ({
                    ...provided,
                    color: "#1890ff",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    color: "#5B728D",
                    fontSize: "18px",
                    fontWeight: "600",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    color: "#4a5568",
                    fontWeight: "600",
                  }),
                }}
                onChange={(value) => form.setFieldsValue({ paymentMethod: value })}
              />
            </Form.Item>
          </div>

          {/* Note */}
          <Form.Item
            name="note"
            rules={[{ required: false }]}
            initialValue={bookingState.note !== "" ? bookingState.note : ""}
          >
            <TextArea
              rows={6}
              className="text-lg font-semibold mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
              placeholder="Napomena"
            />
          </Form.Item>

          {/* Submit Button */}
          <Form.Item>
            <Button
              type="submit"
              htmlType="submit"
              className="w-80 text-xl bg-buttonYellow text-footerBlue hover:bg-footerBlue hover:text-white font-bold py-6 rounded-[33px]"
            >
              PREGLEDAJ REZERVACIJU
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
